module.exports = __webpack_public_path__ + "img/video-21.fe1f095c.png";